import React from 'react';
import { DesktopOrTabletContainer, MobileContainer } from '../../../responsiveTools/ResponsiveContainers';
import { DesktopMisTareasDocuments } from './DesktopMisTareas/DesktopMisTareasDocuments';
import { MobileMisTareasDocuments } from './MobileMisTareas/mobileMisTareasDocuments';

export const MisTareasDocumentsContent = () => {
    return (
        <>
            <DesktopOrTabletContainer>
                <DesktopMisTareasDocuments />
            </DesktopOrTabletContainer>
            <MobileContainer>
                <MobileMisTareasDocuments />
            </MobileContainer>
        </>
    );
}
